import makeStyles from '@mui/styles/makeStyles';

const adjustPolicyUtilizationStyle = makeStyles(
  {
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
    },
    searchRow: {
      display: 'flex',
      alignItems: 'center',
      gap: '16px',
    },
    columns: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: '0 32px',
    },
    column: {
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
    },
    adjustmentRow: {
      display: 'flex',
      alignItems: 'center',
      gap: '16px',
    },
    subtitle: {
      color: '#373f51',
      fontWeight: '500',
      marginBottom: '10px',
    },
    bar: {
      display: 'flex',
      justifyContent: 'space-between',
      background: '#f8f7f3',
      padding: '2px 8px',
      marginBottom: '16px',
    },
  },
  { name: 'adjust-policy-utilization' }
);

export { adjustPolicyUtilizationStyle };
